var sliders = document.querySelectorAll('.js-testimonial-cards-slider');

sliders.forEach(function (slider, index) {
  let uniqueClass = 'js-testimonial-cards-slider-index-' + (index + 1);
  slider.classList.add(uniqueClass);

  // Initialize Swiper using the unique class
  new Swiper('.' + uniqueClass, {
    loop: false,
    slidesPerView: 'auto',
    spaceBetween: 16,
    mousewheel: {
      forceToAxis: true,
      sensitivity: 3
    },
    freeMode: true,
    navigation: {
      nextEl: slider.querySelector('.swiper-button-next'),
      prevEl: slider.querySelector('.swiper-button-prev'),
    },
  });
});
